import React, { useState } from "react";
import { Grid, Card, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import UploadData from "./UploadData";
import ClearDatabase from "./ClearDatabase";
import PresetDataSelector from "./PresetDataSelector";
import PresetDataTable from "./PresetDataTable";
import LoadingOverlay from "./LoadingOverlay";
import StoreSelector from "components/StoreSelector";
import MDSnackbar from "components/MDSnackbar";
import { useAuth0 } from "@auth0/auth0-react";

const SettingsPanel = () => {
  const { user } = useAuth0();

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackBarType, setSnackBarType] = useState("success");
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [presetData, setPresetData] = useState(null);
  const [selectedPreset, setSelectedPreset] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStore, setSelectedStore] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const stores = [
    { id: "store1", name: "Store 1" },
    { id: "store2", name: "Store 2" },
    // Add more stores as needed
  ];

  const handleStoreChange = (storeId) => {
    setSelectedStore(storeId);
  };

  const handleSnackBarOpen = (type, message) => {
    setSnackBarType(type);
    setSnackBarMessage(message);
    setSnackBarOpen(true);
  };

  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarOpen(false);
  };

  const handleLoading = (loading) => {
    setIsLoading(loading);
  };

  const handleCloseNotification = () => setShowNotification(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3}>
                <Typography variant="h5" gutterBottom>
                  Settings
                </Typography>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <StoreSelector
                      stores={stores}
                      selectedStore={selectedStore}
                      onStoreChange={handleStoreChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <UploadData
                      onSnackBarOpen={handleSnackBarOpen}
                      setPresetData={setPresetData}
                      selectedPreset={selectedPreset}
                      onLoading={handleLoading}
                      selectedStore={selectedStore}
                      setShowNotification={setShowNotification}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ClearDatabase
                      onSnackBarOpen={handleSnackBarOpen}
                      onLoading={handleLoading}
                      selectedStore={selectedStore}
                      userId={user.sub}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <PresetDataSelector
                      setPresetData={setPresetData}
                      setSelectedPreset={setSelectedPreset}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <PresetDataTable presetData={presetData} />
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <LoadingOverlay isLoading={isLoading} />
      <MDSnackbar
        color="warning"
        icon="warning"
        title="No Store Selected"
        content="Please select a store before uploading data."
        open={showNotification}
        onClose={handleCloseNotification}
        close={handleCloseNotification}
        bgWhite
      />
    </DashboardLayout>
  );
};

export default SettingsPanel;
